import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Box, Button, Stack
} from '@mui/material'
import { PrinterOutlined } from '@ant-design/icons'
import AnimateButton from 'components/@extended/AnimateButton'
import { A4OrderLayout } from './Order.Print.Layout'
import { usePrint } from '../../hooks/useOrderExport'

const OrderPrintDialog = ({ order, onClose }) => {
    const printRef = useRef()
    const print    = usePrint(printRef, `Order-${order?.order_number}`)

    return (
        <Box>
            <DialogTitle>Print Order</DialogTitle>

            <DialogContent dividers>
                <Stack spacing={3}>
                    {/* Preview */}
                    <Box sx={{
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        bgcolor: '#f5f5f5',
                        maxHeight: '500px',
                        overflow: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        p: 2
                    }}>
                        <div ref={printRef}>
                            <A4OrderLayout order={order} />
                        </div>
                    </Box>
                </Stack>
            </DialogContent>

            <DialogActions sx={{ p: 1.5 }}>
                <AnimateButton>
                    <Button variant="outlined" color="secondary" onClick={onClose}>
                        Cancel
                    </Button>
                </AnimateButton>
                <AnimateButton>
                    <Button variant="contained" color="primary" startIcon={<PrinterOutlined />} onClick={print}>
                        Print
                    </Button>
                </AnimateButton>
            </DialogActions>
        </Box>
    )
}

OrderPrintDialog.propTypes = {
    order:   PropTypes.object.isRequired,
    onClose: PropTypes.func,
}

export default OrderPrintDialog